import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const routes = [
  {
    path: "/shoppanel/shopCategoryControl",
    name: "مدیریت دسته بندی فروشگاه",
    icon: <FontAwesomeIcon icon={"list"} className="text-secondary" />,
    online: true,
    offline: false,
  },
  {
    path: "/shoppanel/selllist",
    name: "فروش ها",
    icon: (
      <FontAwesomeIcon icon={"comments-dollar"} className="text-secondary" />
    ),
    online: true,
    offline: true,
  },
  {
    path: "/shoppanel/paylist",
    name: "پرداخت ها",
    icon: <FontAwesomeIcon icon={"dollar"} className="text-secondary" />,
    online: true,
    offline: true,
  },
  {
    path: "/shoppanel/localpaylist",
    name: "پرداخت ها",
    icon: <FontAwesomeIcon icon={"dollar"} className="text-secondary" />,
    online: false,
    offline: true,
  },
  // {
  //   path: "/shoppanel/cashbacklist",
  //   name: "لیست کش بک ها",
  //   icon: <FontAwesomeIcon icon={"marker"} className="text-secondary" />,
  //   online: true,
  //   offline: true,
  // },
  {
    path: "/shoppanel/coin",
    name: "کیف پول من",
    icon: <FontAwesomeIcon icon={"wallet"} className="text-secondary" />,
    online: true,
    offline: true,
  },
  {
    path: "/shoppanel/returned",
    name: "لیست مرجوعی ها",
    icon: <FontAwesomeIcon icon={"wallet"} className="text-secondary" />,
    online: true,
    offline: false,
  },
  {
    path: "/shoppanel/shopgallery",
    name: "گالری تصاویر",
    icon: (
      <FontAwesomeIcon icon={"photo-film"} className="text-secondary" />
    ),
    online: false,
    offline: true,
  },
  {
    path: "/shoppanel/information",
    name: "اطلاعات فروشگاه",
    icon: <FontAwesomeIcon icon={"info-circle"} className="text-secondary" />,
    online: true,
    offline: true,
  },
  // {
  //   path: "/shoppanel/coin",
  //   name: "در انتظار",
  //   icon: <FontAwesomeIcon icon={"wallet"} className="text-secondary" />,
  //   online: false,   // Display for online
  //   offline: true,
  // },
  // {
  //   path: "/shoppanel/coin",
  //   name: "ثبت فروش دستی",
  //   icon: <FontAwesomeIcon icon={"wallet"} className="text-secondary" />,
  //   online: false,   // Display for online
  //   offline: true,
  // },
  // {
  //   path: "/shoppanel/coin",
  //   name: "ثبت فروش دستی",
  //   icon: <FontAwesomeIcon icon={"wallet"} className="text-secondary" />,
  //   online: false,   // Display for online
  //   offline: true,
  // },
];
